// Styles
import '../scss/order.scss';

// Scripts
import '@shop/frontend/dist/desktop/order-full-form';
import './custom/social-proof.js';

$(document).ready(function () {
  function checkProduct() {
    if ($('.product1').hasClass('active') || $('.product2').hasClass('active')) {
      $('#shipping_plus').prop('disabled', true);
      $('#shipping_plus').prop('checked', false);
      $('.cont').addClass('noHover');
    } else {
      $('#shipping_plus').prop('disabled', false);
      $('#shipping_plus').prop('checked', true);
      $('.cont').removeClass('noHover');
    }
  }
  checkProduct();

  $('.product').on('click', function () {
    $('.product').removeClass('active');
    $(this).addClass('active');
    checkProduct();
  });

  $('select')
    .on('change', function () {
      const $select = $(this);
      if ($select.val() == '') {
        $select.css('color', '#8f91a4');
      } else {
        $select.css('color', '#1c1c28');
      }
    })
    .change();
});
